import React from 'react';
export const Loader = _ref => {
  let {
    type = 'spinner'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "spinner-container"
  }, type === 'spinner' ? /*#__PURE__*/React.createElement("div", {
    className: "loader-spinner"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "horizontal-loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bar"
  })));
};